import { StreamTextUtils } from "./StreamTextUtils";

// const BLUEBERRY_API_V1_BASE = "https://blueberry.cerebralzip.com/api/v1";
const BLUEBERRY_API_V1_BASE = "https://ungapchat5674local.cerebralzip.com/api/v1";





export class DeepResearchStreamClient {
  constructor({ streamTextUtils } = {}) {
    this.streamTextUtils = streamTextUtils || new StreamTextUtils();
  }

  async stream({
    message,
    chatSessionId,
    messages,
    selectedDepartments,
    language,
    useMemory,
    token,
    onDelta,
    onDone,
    onError,
  }) {
    try {
      const deepUrl = `${BLUEBERRY_API_V1_BASE}/chat_gad_deep_research/${encodeURIComponent(
        chatSessionId || "default",
      )}`;
      const deepPayload = {
        messages:
          Array.isArray(messages) && messages.length > 0
            ? messages
            : [
                {
                  role: "user",
                  content: message,
                  annotations: null,
                  metadata: {},
                },
              ],
        gad_type:
          Array.isArray(selectedDepartments) && selectedDepartments.length > 0
            ? selectedDepartments
            : [""],
        language: language || "ma",
        use_memory: typeof useMemory === "boolean" ? useMemory : true,
        action_type: "shodh_server",
        data: null,
      };

      const res = await fetch(deepUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(deepPayload),
      });

      if (!res.body) throw new Error("ReadableStream not supported");

      const reader = res.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";

      let indexedSources = [];
      let currentMemory = "";
      let currentAnswer = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        buffer += chunk;

        const combinedSources =
          this.streamTextUtils.extractCombinedSourcesFromText(buffer);
        if (Array.isArray(combinedSources) && combinedSources.length > 0) {
          indexedSources = this.streamTextUtils.indexSourcesByContextId(
            combinedSources,
          );
        }

        const memRe = /memory:\s*"([\s\S]*?)"/g;
        const zeroRe = /\b0:\s*"([\s\S]*?)"/g;

        let memMatch;
        const memoryParts = [];
        while ((memMatch = memRe.exec(buffer)) !== null)
          memoryParts.push(memMatch[1]);

        let zeroMatch;
        const zeroParts = [];
        while ((zeroMatch = zeroRe.exec(buffer)) !== null)
          zeroParts.push(zeroMatch[1]);

        if (zeroParts.length === 0) {
          const zeroLineRe = /^\s*0:\s*(.*)$/gm;
          let lineMatch;
          while ((lineMatch = zeroLineRe.exec(buffer)) !== null)
            zeroParts.push(lineMatch[1]);
        }

        currentMemory = this.streamTextUtils.normalizeApiText(
          memoryParts.join(""),
        );
        currentAnswer = this.streamTextUtils.normalizeApiText(
          zeroParts.join(""),
        );

        onDelta?.({
          text: currentAnswer,
          thinking: currentMemory || undefined,
          contextArray: indexedSources || [],
        });
      }

      const finalCombinedSources =
        this.streamTextUtils.extractCombinedSourcesFromText(buffer);
      if (
        Array.isArray(finalCombinedSources) &&
        finalCombinedSources.length > 0
      ) {
        indexedSources = this.streamTextUtils.indexSourcesByContextId(
          finalCombinedSources,
        );
      }

      onDone?.({ contextArray: indexedSources || [] });
    } catch (e) {
      onError?.(e);
    }
  }
}
